const liabilityTypes = [
  {
    value: 'loan',
    label: 'Loan',
    subtypes: [
      { value: 'generic', label: 'Generic Loan' },
      { value: 'mortgage', label: 'Mortgage' },
      { value: 'student', label: 'Student Loan' },
    ],
  },
];

export default liabilityTypes;
